// extracted by mini-css-extract-plugin
export default {"file-tree-row":"DiffFileTree-module__file-tree-row--yr73E"};